import { getText } from '../text/text-service';
import { numberWithSpaces } from '../../utils/stringUtils';

export const resolvePaymentTerm = (paymentTerm: number): string => {
    if (paymentTerm == 12) {
        return getText('webshopsweden.common.summaryPage.overview.month');
    } else if (paymentTerm == 2) {
        return getText(
            'webshopsweden.common.summaryPage.overview.halfYearPayment'
        );
    } else if (paymentTerm == 4) {
        return getText(
            'webshopsweden.common.summaryPage.overview.quarterPayment'
        );
    }
    return getText('webshopsweden.common.summaryPage.overview.yearlyPayment');
};

export const resolveMileage = (mileage: number): string => {
    if (mileage != 98) {
        return numberWithSpaces(mileage * 1000) + ' km';
    } else return 'Obegränsad';
};

export const resolveDriverUnder24 = (under24: string): string => {
    return under24 === 'N'
        ? getText('webshopsweden.common.no')
        : getText('webshopsweden.common.yes');
};

export const resolveChosenInsuranceName = (
    chosenInsurance: number,
    plusPackage: boolean
) => {
    if (chosenInsurance === 0) {
        if (plusPackage) {
            return (
                getText(
                    'webshopsweden.products.car.insurance.trafikInsurance'
                ) +
                ' + ' +
                getText('webshopsweden.common.plusPackage')
            );
        } else
            return getText(
                'webshopsweden.products.car.insurance.trafikInsurance'
            );
    } else if (chosenInsurance === 1) {
        if (plusPackage) {
            return (
                getText('webshopsweden.products.car.insurance.halvInsurance') +
                ' + ' +
                getText('webshopsweden.common.plusPackage')
            );
        } else
            return getText(
                'webshopsweden.products.car.insurance.halvInsurance'
            );
    } else {
        if (plusPackage) {
            return (
                getText('webshopsweden.products.car.insurance.helInsurance') +
                ' + ' +
                getText('webshopsweden.common.plusPackage')
            );
        } else
            return getText('webshopsweden.products.car.insurance.helInsurance');
    }
};
